import React from "react";
import { Redirect } from "react-router-dom";
import { DASHBOARD } from "../routes/paths";

const Error404 = () => {
  return <Redirect to={DASHBOARD} />;
};

export default Error404;
